import Icon from "@ant-design/icons";

const SaunaSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M1835 5025 c-14 -13 -25 -36 -25 -50 0 -14 -18 -60 -41 -103 -36 -69
-40 -85 -40 -147 0 -62 4 -79 40 -148 46 -89 50 -117 21 -167 -44 -76 -60
-121 -61 -170 -2 -61 19 -90 65 -90 47 0 72 23 80 71 4 23 22 70 42 105 59
105 56 206 -8 306 -39 62 -40 120 -3 176 30 45 55 120 55 164 0 36 -40 78 -75
78 -14 0 -37 -11 -50 -25z"
      />
      <path
        d="M2556 5029 c-17 -13 -26 -30 -26 -48 0 -15 -18 -61 -39 -102 -22 -41
-42 -94 -46 -119 -8 -59 9 -133 46 -194 47 -76 47 -99 0 -187 -51 -98 -62
-163 -31 -201 15 -20 30 -28 54 -28 46 0 67 19 76 72 5 25 22 67 39 93 36 57
55 140 46 198 -4 23 -25 77 -47 119 -47 89 -46 113 2 187 33 53 54 131 45 173
-13 55 -72 74 -119 37z"
      />
      <path
        d="M3273 5028 c-12 -13 -25 -41 -29 -63 -4 -22 -20 -60 -35 -85 -62
-101 -63 -200 -3 -307 46 -82 47 -126 6 -191 -54 -84 -65 -162 -31 -206 41
-52 129 -22 129 44 0 15 18 62 41 104 36 69 41 86 41 146 0 68 -12 104 -62
190 -28 49 -25 83 16 155 38 68 56 148 42 185 -19 52 -80 66 -115 28z"
      />
      <path
        d="M1439 3875 c-273 -55 -538 -278 -650 -546 -97 -236 -97 -500 1 -731
60 -140 184 -295 320 -400 l35 -27 -135 -1 c-151 0 -228 -14 -345 -59 -254
-98 -488 -332 -586 -586 -61 -158 -72 -216 -73 -390 0 -176 9 -230 67 -383 86
-230 265 -434 487 -555 93 -51 259 -104 370 -117 68 -8 647 -10 2050 -8 1884
3 1956 4 1990 22 49 26 98 74 123 121 17 31 22 58 22 115 0 85 -20 133 -77
186 -55 52 -95 67 -190 72 l-87 4 58 49 c73 61 158 172 204 264 132 269 129
540 -9 804 -59 111 -122 189 -218 266 -136 110 -302 180 -455 192 l-76 6 0 82
c0 73 -3 86 -30 130 -42 68 -105 106 -189 112 l-65 6 58 57 c220 217 292 556
178 840 -91 225 -279 393 -522 466 -56 17 -132 18 -1125 20 -854 2 -1078 0
-1131 -11z m349 -168 c244 -85 407 -295 429 -552 12 -149 -54 -342 -156 -456
-207 -232 -515 -263 -719 -74 -194 180 -205 461 -25 655 115 124 268 166 393
109 78 -36 114 -71 149 -141 71 -141 21 -316 -112 -392 -65 -37 -100 -41 -152
-16 -55 27 -91 91 -81 145 8 40 46 90 86 110 57 30 56 102 -3 135 -26 14 -31
13 -85 -16 -142 -76 -190 -258 -107 -400 75 -127 241 -176 378 -110 89 43 171
124 214 215 32 66 38 88 41 164 10 197 -81 354 -253 437 -126 62 -265 60 -400
-5 -200 -97 -328 -288 -342 -511 -18 -282 156 -536 427 -626 58 -19 95 -22
330 -27 146 -3 271 -10 278 -15 20 -13 40 -64 34 -91 -2 -13 -15 -34 -29 -47
-25 -23 -26 -23 -281 -22 -228 2 -266 4 -337 23 -360 96 -597 400 -597 766 0
358 241 674 580 760 88 23 249 14 340 -18z m712 -13 c359 -271 359 -877 0
-1148 l-62 -46 -183 0 -184 0 55 52 c102 96 174 218 216 364 31 111 31 286 0
397 -42 146 -131 291 -235 381 l-52 46 192 0 191 0 62 -46z m699 -3 c58 -69
116 -171 147 -260 27 -77 61 -121 92 -121 25 0 62 28 71 54 15 38 -40 188
-110 303 -21 36 -39 67 -39 69 0 13 216 2 282 -15 286 -73 477 -316 478 -607
0 -173 -58 -313 -185 -439 -135 -136 -235 -175 -447 -175 -70 0 -128 3 -128 6
0 3 8 18 19 32 31 45 92 173 118 247 20 60 53 221 53 263 0 24 -48 62 -78 62
-47 0 -67 -33 -86 -144 -26 -157 -98 -316 -191 -423 l-37 -43 -239 0 -240 0
51 63 c65 80 122 190 156 302 26 83 28 103 28 255 0 152 -2 172 -28 255 -34
111 -92 223 -156 303 l-50 62 239 0 239 0 41 -49z m874 -1353 c53 -28 63 -88
23 -135 l-24 -28 -482 -5 c-462 -5 -482 -6 -496 -24 -16 -23 -18 -59 -4 -86
17 -32 67 -40 241 -40 l167 0 40 -47 c211 -254 287 -607 202 -938 -28 -108
-116 -284 -187 -372 l-57 -73 -519 0 -519 0 44 53 c104 122 173 256 214 412
23 85 27 122 27 245 1 103 -4 168 -17 224 -35 159 -111 312 -212 432 l-55 64
169 0 c183 0 223 8 241 46 16 35 14 47 -10 78 l-20 26 -295 0 -295 0 6 22 c4
11 7 42 7 68 0 26 -3 57 -7 68 l-6 22 901 0 c666 0 907 -3 923 -12z m-2853
-352 c217 -77 380 -240 457 -461 25 -73 28 -92 28 -225 0 -133 -3 -152 -28
-225 -40 -113 -99 -208 -182 -290 -79 -78 -151 -125 -253 -163 -56 -21 -85
-26 -177 -26 -128 -1 -204 20 -295 81 -67 44 -104 47 -137 9 -12 -15 -23 -36
-23 -46 0 -35 52 -80 144 -125 136 -66 199 -75 501 -75 201 0 262 -3 283 -14
77 -40 72 -163 -8 -196 -21 -9 -109 -11 -322 -8 -262 4 -302 7 -373 26 -209
57 -407 196 -525 367 -47 69 -107 201 -131 290 -32 115 -32 335 0 450 71 262
240 469 480 590 123 61 194 76 351 71 114 -3 147 -8 210 -30z m1062 -16 c130
-96 243 -269 289 -445 31 -117 32 -318 1 -433 -28 -103 -67 -192 -120 -268
-45 -66 -147 -168 -207 -208 l-40 -26 -346 0 -347 0 92 93 c97 99 138 159 191
284 52 119 69 222 62 372 -7 151 -22 214 -87 346 -56 113 -126 204 -218 282
l-62 53 362 0 363 0 67 -50z m2142 30 c129 -33 228 -91 331 -195 73 -72 99
-107 133 -175 60 -121 76 -193 76 -330 0 -178 -47 -319 -153 -450 -135 -168
-290 -247 -502 -259 -95 -5 -121 -10 -138 -25 -28 -25 -27 -73 1 -103 l21 -23
344 0 c288 0 349 -2 373 -15 32 -17 60 -61 60 -95 0 -34 -28 -78 -60 -95 -26
-13 -216 -15 -1608 -15 l-1579 0 14 55 c12 47 12 63 0 110 l-14 55 1083 0
c595 0 1090 3 1099 6 8 4 23 20 31 36 13 25 13 35 3 59 -17 43 -36 49 -148 49
l-100 0 54 85 c189 301 231 683 114 1026 -26 77 -91 208 -130 266 -16 23 -29
44 -29 47 0 3 146 6 323 6 289 0 332 -2 401 -20z"
      />
      <path
        d="M924 1800 c-236 -33 -452 -231 -530 -485 -26 -83 -26 -286 -1 -368
10 -32 27 -67 37 -77 26 -26 74 -26 100 0 24 24 25 59 5 137 -45 173 11 370
144 502 112 111 238 160 365 140 116 -19 215 -93 265 -199 22 -47 26 -69 26
-150 0 -82 -4 -103 -26 -151 -49 -105 -162 -189 -251 -189 -90 1 -167 78 -168
168 0 55 33 119 72 140 77 41 96 86 57 136 -29 37 -74 35 -135 -7 -100 -69
-151 -174 -142 -292 10 -116 74 -212 176 -262 49 -24 69 -28 142 -28 76 0 92
4 150 32 123 61 210 160 256 292 33 93 33 229 0 322 -81 230 -307 371 -542
339z"
      />
    </g>
  </svg>
);

const SaunaIcon = (props) => <Icon component={SaunaSvg} {...props} />;

export default SaunaIcon;
